import type { UserData } from '@/features/auth/types'

export const getUserDisplayName = (user?: UserData): string =>
  [user?.token?.given_name, user?.token?.family_name].filter(Boolean).join(' ').trim() || user?.username || ''
